import { BaseDto } from '../base.dto';

export class GiftCardPhysicalCardPaymentDto extends BaseDto {
    giftCardPhysicalCardId: number;
    paymentId: number;
}
